import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "@/plugins/i18n";
import { authGuard } from "@tt/vue-auth0";

Vue.use(VueRouter);

const routes = [
  {
    path: "/requests",
    name: "requestsOverview",
    menuTitle: i18n.tc("requests.title", 2),
    menuIcon: "mdi-bank-transfer",
    showIcon: false,
    component: () => import("@/views/RequestsView.vue"),
    active: true
  },
  {
    path: "/",
    redirect: "/requests",
    // name: "dashboard",
    // menuTitle: i18n.t("dashboard.title"),
    // menuIcon: "mdi-home-outline",
    // showIcon: false,
    // component: () => import("@/views/Dashboard"),
    showIcon: false,
    active: false
  },
  {
    path: "/locations",
    name: "locationsOverview",
    menuTitle: i18n.tc("locations.title", 2),
    menuIcon: "mdi-store",
    showIcon: false,
    component: () => import("@/views/LocationsView.vue"),
    active: true
  },
];

// create router
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

// auth check
router.beforeEach(authGuard);

export default router;
